import aemClientService from '@/services/aem/aemClientService';
import type {MarketConfigModel} from '@/types/aem';

let config: MarketConfigModel = {};

export const initConfig = async (market: string) => {
    const configData = await aemClientService.initMarketConfig(market);

    config = {...configData};
};

export const getConfig = (): MarketConfigModel => config;
